import { FormTemplate } from "db/definitions";

/**
 * Enforces all the properties are in the document before being sent to the UpdateTemplateForm component for editing.
 * @param template document from the cloud
 * @returns a full form template.
 */
function enforceFormTemplateDoc(
	template: Partial<Omit<FormTemplate, "id" | "template" | "group" | "readGroups">> & { id: string; template: string; group: string; readGroups: string[] },
): FormTemplate {
	const newTemplate: FormTemplate = {
		id: template.id,
		template: template.template,
		templateName: template.templateName || "",
		type: template.type || "default",
		description: template.description || "",
		fieldsOrder: template.fieldsOrder ? [...template.fieldsOrder] : [],
		formTemplateGroup: template.formTemplateGroup || "Test",
		imagesPerPage: template.imagesPerPage || 0,
		exportType: template.exportType || "docx",
		createdAt: template.createdAt || new Date().toISOString(),
		updatedAt: template.updatedAt || new Date().toISOString(),
		deleted: template.deleted || false,
		exportInstruction: template.exportInstruction || "",
		group: template.group,
		readGroups: [...template.readGroups],
	};

	if (template.version) {
		const { version, versionName } = template;
		newTemplate.version = version;
		newTemplate.versionName = versionName;
	}

	if (template.projectId) {
		newTemplate.projectId = template.projectId;
	}

	if (template.publish !== null) {
		newTemplate.publish = template.publish;
	}

	return newTemplate;
}

export default enforceFormTemplateDoc;
